import(/* webpackMode: "eager" */ "/tmp/8df23e1ab81b7a9/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8df23e1ab81b7a9/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df23e1ab81b7a9/src/app/metrics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8df23e1ab81b7a9/src/components/ClientInit/ClientInit.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df23e1ab81b7a9/src/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8df23e1ab81b7a9/src/styles/global.scss");
